<script>
  // Every source, with the datasets it fills and where its latest export
  // stands, and what is done to one (docs/ref-belonging-plan.md, step 7.2):
  // ingest it (its waiting rows or a new export) and its mapping.
  import Async from '../components/Async.svelte';
  import Alert from '../components/Alert.svelte';
  import Button from '../components/Button.svelte';
  import Panel from '../components/Panel.svelte';
  import HelpDrawer from '../components/HelpDrawer.svelte';
  import { getSources, getDatasets } from '../lib/api.js';
  import { HELP } from '../lib/help.js';
  import { mayVisit } from '../lib/session.svelte.js';
  import { exportState } from '../lib/datasets.js';

  async function load() {
    const [{ sources }, { datasets }] = await Promise.all([getSources(), getDatasets()]);
    return { sources, datasets };
  }
  const state = load();
  // One source can fill several datasets (CTL's intake).
  const fills = (datasets, id) => datasets.filter((d) => d.sources.some((s) => s.id === id));
  const q = (id) => encodeURIComponent(id);
</script>

<HelpDrawer {...HELP.sources} />
<h1 class="wf2-title wf2-title-level-1">Sources</h1>
<p class="wf2-subtitle">Where the data in each dataset comes from: an export, read in by its mapping.</p>

<Async promise={state} loading="Reading your sources…">
  {#snippet children({ sources, datasets })}
    {#if !sources.length}
      <Alert title="No source yet" variant="info"><p>A source is added with a new dataset, or to an existing one.</p></Alert>
    {:else}
      <Panel>
        <div class="wf2-tablewrap"><table class="wf2-table">
          <thead><tr><th>Source</th><th>Fills</th><th>Rows</th><th>Latest</th><th></th></tr></thead>
          <tbody>
            {#each sources as s}
              <tr>
                <td>{s.label}<span class="col-stats mono">{s.id}</span></td>
                <td>
                  {#each fills(datasets, s.id) as d, i}{#if i}, {/if}<a href={`#/data/dataset?id=${q(d.id)}`}>{d.label}</a>{:else}—{/each}
                </td>
                <td>{s.rowsInSource ?? '—'}</td>
                <td>{exportState(s)}</td>
                <td><div class="wf2-row" style="gap:6px; flex-wrap:wrap">
                  {#if mayVisit('source/ingest')}<Button variant="ghost" to={`source/ingest?id=${q(s.id)}`}>Ingest</Button>{/if}
                  {#if mayVisit('source/mapping')}<Button variant="ghost" to={`source/mapping?id=${q(s.id)}`}>Mapping</Button>{/if}
                </div></td>
              </tr>
            {/each}
          </tbody>
        </table></div>
      </Panel>
    {/if}
    {#if mayVisit('dataset/new')}
      <div class="wf2-row" style="gap:12px"><Button variant="secondary" to="dataset/new?add=1">New source</Button></div>
    {/if}
  {/snippet}
</Async>
